module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/7-4eeca61724ad0b49eafa5d03a5a151f3.png";